import flexAbdomenExcellent from './flexibility-abdomen-excellent.png';
import flexAbdomenAverage from './flexibility-abdomen-average.png';
import flexAbdomenFair from './flexibility-abdomen-fair.png';
import flexAbdomenPoor from './flexibility-abdomen-poor.png';
import hipExcellent from './hip-excellent.png';
import hipAverage from './hip-average.png';
import hipFair from './hip-fair.png';
import hipPoor from './hip-poor.png';
import thighExcellent from './thigh-excellent.png';
import thighAverage from './thigh-average.png';
import thighFair from './thigh-fair.png';
import thighPoor from './thigh-poor.png';
import lateralAbdomenExcellent from './lateral-abdomen-excellent.png';
import lateralAbdomenAverage from './lateral-abdomen-average.png';
import lateralAbdomenFair from './lateral-abdomen-fair.png';
import lateralAbdomenPoor from './lateral-abdomen-poor.png';
import shoulderAbduction180Optimal from './shoulder-abduction-180-optimal.png';
import shoulderAbduction180Limited from './shoulder-abduction-180-limited.png';
import shoulderAbduction180VeryLimited from './shoulder-abduction-180-very-limited.png';
import shoulderAbduction60Optimal from './shoulder-abduction-60-optimal.png';
import shoulderAbduction60Limited from './shoulder-abduction-60-limited.png';
import shoulderAbduction60VeryLimited from './shoulder-abduction-60-very-limited.png';
import externalRotationOptimal from './external-rotation-optimal.png';
import externalRotationLimited from './external-rotation-limited.png';
import externalRotationVeryLimited from './external-rotation-very-limited.png';
import internalRotationOptimal from './internal-rotation-optimal.png';
import internalRotationLimited from './internal-rotation-limited.png';
import internalRotationVeryLimited from './internal-rotation-very-limited.png';

export const backFitnessImages = {
  flexAbdomen: [flexAbdomenExcellent, flexAbdomenAverage, flexAbdomenFair, flexAbdomenPoor],
  hip: [hipExcellent, hipAverage, hipFair, hipPoor],
  thigh: [thighExcellent, thighAverage, thighFair, thighPoor],
  lateralAbdomen: [lateralAbdomenExcellent, lateralAbdomenAverage, lateralAbdomenFair, lateralAbdomenPoor],
};

export const jointRangesImages = {
  shoulderAbduction180: [shoulderAbduction180Optimal, shoulderAbduction180Limited, shoulderAbduction180VeryLimited],
  shoulderAbduction60: [shoulderAbduction60Optimal, shoulderAbduction60Limited, shoulderAbduction60VeryLimited],
  externalRotation: [externalRotationOptimal, externalRotationLimited, externalRotationVeryLimited],
  internalRotation: [internalRotationOptimal, internalRotationLimited, internalRotationVeryLimited],
};
